import type { IReportRow } from "../../../../models/report.dto";

const isPlaceholderLabel = (value: unknown) =>
  value === null ||
  value === undefined ||
  (typeof value === "string" &&
    ["", "-"].includes(value.trim().toLocaleLowerCase()));

const isLegacyTotalLabel = (value: unknown) =>
  typeof value === "string" && value.trim().toLocaleLowerCase() === "total";

const isSummaryTextValue = (value: unknown) =>
  typeof value !== "string" ||
  isLegacyTotalLabel(value) ||
  isPlaceholderLabel(value);

const isLegacyTotalSummaryRow = (row: IReportRow) =>
  Object.values(row.values).some((value) => isLegacyTotalLabel(value)) &&
  Object.values(row.values).every((value) => isSummaryTextValue(value));

const isTotalRow = (row: IReportRow) => row.isTotal || isLegacyTotalSummaryRow(row);

const isZeroTotalSummaryRow = (row: IReportRow) => {
  const numericValues = Object.values(row.values).filter(
    (value): value is number =>
      typeof value === "number" && Number.isFinite(value),
  );

  return (
    isTotalRow(row) &&
    numericValues.length > 0 &&
    numericValues.every((value) => value === 0)
  );
};

export const normalizeEmptyReportRows = (rows: IReportRow[]) =>
  rows.length === 1 && isZeroTotalSummaryRow(rows[0]) ? [] : rows;
